import { render, staticRenderFns } from "./OrderListElement.vue?vue&type=template&id=1380b93d&"
import script from "./OrderListElement.vue?vue&type=script&lang=js&"
export * from "./OrderListElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports